import {css, objectToStyles} from '../utils.js';
import chroma from 'chroma-js';

const datePickerStyles = css`
    .ddk-container.ddk-container .dash-datepicker-input-wrapper {
        ${props => objectToStyles(props.theme.border_style)}
        border-width: ${props => props.theme.control_border.width ?? '1px'};
        border-radius: ${props => props.theme.control_border.radius ?? '4px'};
        border-color: ${props => props.theme.control_border.color};
        background-color: ${props => props.theme.control_background_color};
        color: ${props => props.theme.control_text};
    }

    .ddk-container.ddk-container .dash-datepicker-input-wrapper:focus-within {
        border-color: var(--Dash-Fill-Interactive-Strong);
    }

    .ddk-container.ddk-container .layout-header .dash-datepicker {
        background-color: inherit;
        color: inherit;
    }

    .ddk-container.ddk-container .dash-datepicker .dash-datepicker-input-wrapper-disabled {
        color: ${props => chroma(props.theme.control_text).alpha(0.8).css()};
        background-color: ${props =>
            chroma(props.theme.control_background_color).alpha(0.5).css()};
        cursor: not-allowed;
    }

    .ddk-container.ddk-container .dash-datepicker input[type='text'] {
        border: none;
        background: transparent;
        height: 38px;
        padding: 0;
    }

    .ddk-container .dash-datepicker-content .dash-datepicker-controls .dash-input {
        width: 102px;
    }

    .ddk-container .dash-datepicker-content button:hover,
    .ddk-container .dash-datepicker-content button:focus {
        color: var(--Dash-Text-Strong);
    }


    .ddk-container
        .global-controls-bar-item-control
        .dash-datepicker
        input.dash-datepicker-input {
        height: 38px !important; /* overrides another "important" rule in ControlsHeader.css.js */
    }

    /* Override Radix popover position to be absolute because of .ddk-container
     * styles (namely container-type: inline-size)
     */
    div[data-radix-popper-content-wrapper]:has(.dash-datepicker-content) {
        position: absolute !important;
    }

    /* When the calendar is portaled outside of the app (with_portal prop),
     * certain Radix styles need to be overridden
     */
    div[data-radix-popper-content-wrapper]:has(.dash-datepicker-portal) {
        position: fixed !important;
        transform: none !important;
    }

    .ddk-container .dash-datepicker-content table th,
    .ddk-container .dash-datepicker-content table td {
        padding: 0;
        border-bottom: none;
        text-align: center;
    }

    .dash-datepicker-portal .dash-datepicker-calendar td.dash-datepicker-calendar-date-inside,
    .ddk-container .dash-datepicker-calendar td.dash-datepicker-calendar-date-inside {
        color: var(--Dash-Text-Strong);
    }

    .dash-datepicker-portal .dash-datepicker-calendar td:hover,
    .ddk-container .dash-datepicker-calendar td:hover {
        background-color: var(--Dash-Fill-Interactive-Weak);
    }

    .dash-datepicker-portal .dash-datepicker-calendar td.dash-datepicker-calendar-date-highlighted,
    .ddk-container .dash-datepicker-calendar td.dash-datepicker-calendar-date-highlighted {
        background-color: color-mix(
            in srgb,
            var(--Dash-Fill-Interactive-Strong) 5%,
            transparent 95%
        );
        color: var(--Dash-Fill-Interactive-Strong);
    }

    .dash-datepicker-portal .dash-datepicker-calendar td.dash-datepicker-calendar-date-selected,
    .ddk-container .dash-datepicker-calendar td.dash-datepicker-calendar-date-selected {
        background-color: var(--Dash-Fill-Interactive-Strong);
        color: var(--Dash-Fill-Inverse-Strong);
    }

    .dash-datepicker-portal .dash-input-container button.dash-input-stepper {
        padding: 0;
    }

    .dash-datepicker-portal .dash-datepicker-controls .dash-input-container {
        height: 38px;
        width: calc(5ch + 40px) !important;
    }

    .dash-datepicker-portal .dash-datepicker-calendar th,
    .dash-datepicker-portal .dash-datepicker-calendar td {
        padding: 0;
        border-bottom: none;
        text-align: center;
    }

    .dash-datepicker-portal .dash-datepicker-close-button {
        padding: 0;
    }
}

`;
export default datePickerStyles;
